import { FC } from 'react';

import { useVoiceToText } from './hooks/useVoiceToText';
import { StatusText, VoiceButton } from './styles';
import { VoiceToTextProps } from './types';

const VoiceToText: FC<VoiceToTextProps> = ({
  className,
  handleTextOutput,
  handleError,
  variant = 'default',
}) => {
  const { isTranscribing, isRecording, startRecording, stopRecording } =
    useVoiceToText({
      handleTextOutput,
      handleError,
    });

  return (
    <div className={`${className} "flex items-center gap-2 justify-between"`}>
      <VoiceButton
        isRecording={isRecording}
        isTranscribing={isTranscribing}
        startRecording={startRecording}
        stopRecording={stopRecording}
        variant={variant}
      />
      <StatusText
        isRecording={isRecording}
        isTranscribing={isTranscribing}
        variant={variant}
      />
    </div>
  );
};

export default VoiceToText;
